import React from 'react';
import MenuOption from './MenuOption';
import { CategoryProps } from './types';

const Category = ({ options, style = {}, hide, containerWidth, containerHeight }: CategoryProps) => {
  return (
    <div style={style}>
      {options.map((option, index) =>
        <MenuOption key={index} {...option} hide={hide} containerWidth={containerWidth} containerHeight={containerHeight} />
      )}
    </div>
  );
};

export default Category;
